import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LucideIcon } from "lucide-react";

export type Submenu = {
  href: string;
  label: string;
  active: boolean;
  flag?: string;
};

export type Menu = {
  href?: string;
  flag?: string;
  label: string;
  active: boolean;
  icon?: LucideIcon;
  iconNode?: any;
  iconName?: string;
  iconNodeName?: string;
  avatar?: string; // Avatar do grupo para modo devocional
  submenus: Submenu[];
};

export type MenuGroup = {
  groupLabel: string;
  menus: Menu[];
};

interface MenuState {
  menuGroups: MenuGroup[];
  isLoading: boolean;
}

const initialState: MenuState = {
  menuGroups: [],
  isLoading: false,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setMenuGroups: (state, action: PayloadAction<MenuGroup[]>) => {
      state.menuGroups = action.payload;
    },
    setMenuLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setMenuGroups, setMenuLoading } = menuSlice.actions;

// Selectors
export const selectMenuGroups = (state: { menu: MenuState }) =>
  state.menu.menuGroups;
export const selectMenuLoading = (state: { menu: MenuState }) =>
  state.menu.isLoading;

export default menuSlice.reducer;
